// API环境配置
const ENV_CONFIG = {
  TEST: {
    // baseURL: 'http://192.168.31.25:8088/',
    baseURL: 'http://1.193.163.25:8088/',
    // baseURL: 'https://testdzlapi.cpolar.top/',
    sendURL: 'https://testsend.iepose.cn/',
    nettyURL: 'http://1.193.163.25:8712/',
    setUrl: 'https://test-send.cpolar.cn/',
    lklURL: 'https://dzlapi.cpolar.cn/lkl/',
  },
  PROD: {
    baseURL: 'https://dzlapi.rcdqiot.com/',
    // baseURL: 'http://192.168.31.30:8088/',
    sendURL: 'https://send.rcdqiot.com/',
    nettyURL: 'https://sendnetty.rcdqiot.com',
    setUrl: 'https://send.cpolar.cn/',
    lklURL: 'https://dzlapi.rcdqiot.com/lkl/',
  },
}
// 当前环境配置
const currentEnv = 'PROD'
// 可切换为 'PROD''TEST'
window.sessionStorage.setItem('开发模式', currentEnv)
const config = ENV_CONFIG[currentEnv]
const { baseURL, sendURL, nettyURL, lklURL, setUrl } = config
import axios from 'axios'
// 创建axios实例
const baseURL1 = axios.create({ baseURL })
const setUrl1 = axios.create({ baseURL: setUrl })
const sendURL1 = axios.create({ baseURL: sendURL })
const nettyURL1 = axios.create({ baseURL: nettyURL })
// URL配置
export const imgUrl = baseURL + 'station/'
export const imgUrls = baseURL + 'img/'
export const imgUrls2 = baseURL + 'kc/'
export const imgUrls3 = lklURL
// 请求拦截器
const setupInterceptors = (instance) => {
  instance.interceptors.request.use((config) => {
    config.headers = {
      'Content-Type': 'application/json',
      ...config.headers,
      token: window.sessionStorage.getItem('token') || '',
      'Captcha-Id': window.sessionStorage.getItem('CaptchaId') || '',
    }
    // 如果是 sendURL 且需要特殊处理
    // if (options.isSendURL) {
    //   // 可以添加特定的 headers
    //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
    // }
    return config
  })
}
const setupInterceptors2 = (instance) => {
  instance.interceptors.request.use((config) => {
    console.log('【请求发出】', config.method, config.url);
    console.log('【完整URL】', config.baseURL, config.url);
    return config
  })
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      console.error('【请求失败】', error.response);
      return Promise.reject(error);
    }
  );
}
// 为所有实例添加拦截器
setupInterceptors(baseURL1)
setupInterceptors2(sendURL1)
setupInterceptors(nettyURL1)
setupInterceptors(setUrl1)
export default {
  baseURL1,
  sendURL1,
  nettyURL1,
  setUrl1,
  imgUrl,
  imgUrls,
  imgUrls2,
  imgUrls3,
}
